import { Component, Shark } from "shark-mvc";
import OrganizationMembership from "../../models/OrganizationMembership";
import User from "../../models/User";

import templateContent from "./project-list.html";
import "./style.css";

import homeView from "../../views/home/homeView";
import projectManager from "../../managers/projectManager";

class ProjectListComponent extends Component {
	constructor () {
		super("projectListComponent");
		this.addTemplate("", templateContent);
	}

	beforeLoad () {
		this.setupFilters();
	}

	filterProjectList (searchKey) {
		const { projectList } = Shark.get();
		let visibleItemCount = 0;

		projectList.forEach(item => {
			if (searchKey === "" || item.clientName.toLowerCase().includes(searchKey) || item.description.toLowerCase().includes(searchKey) || item.name.toLowerCase().includes(searchKey)) {
				// item.__cssClasses.add("render");
				item.__renderer.addClasses("render");
				visibleItemCount++;
			}
			else {
				// item.__cssClasses.delete("render");
				item.__renderer.removeClasses("render");
			}
			// item.flattenCSSClasses();
		});

		Shark.set({
			__visibleProjectCount: visibleItemCount,
		});
	}

	setupFilters () {
		if (!Shark.$store.projectFilters) {
			const projectFilters = Shark.getInstance("__smart__", {
				organizationGuidList: [],
				searchKey: "",
				statusList: [],
				onDataChanged: function (data) {
					// console.log("projectFilters.onDataChanged", this, data);
					localStorage.projectFilters = JSON.stringify(this.export());

					if (data.property === "searchKey") {
						const searchKey = this.searchKey.toLowerCase();
						projectListComponent.filterProjectList(searchKey);
						Shark.set({
							__projectFilterActiveCSSClass: searchKey === "" ? "" : "active-filter",
						});
					}
					else {
						projectListComponent.refreshProjectList();
						
						// Dave: Così ad ogni cambio viene deciso se mostrare "tutti" o "nessuno".
						Shark.set({
							__allOrganizationSelected: projectFilters.organizationGuidList.length === Shark.$store.organizationList.length,
						});
					}
				},
			});

			if (localStorage.projectFilters) {
				// Dave: disastro: quando parso devo verificare che nella lista salvata non ci siano cose che non ho nella lista relativa (es: una organizazzione o un progetto che non posso più vedere)
				projectFilters.import(JSON.parse(localStorage.projectFilters));
			}

			Shark.set({
				projectFilters,
				__projectFilterActiveCSSClass: projectFilters.searchKey === "" ? "" : "active-filter",
			});

			if (!localStorage.projectFilters) {
				projectFilters.set({
					organizationGuidList: Shark.$store.organizationList.map(item => item.guid),
					statusList: [1],
				});
			}
		}
	}

	init () {
		this.setupFilters();
	}
	
	matchProjectAndOrganization () {
		const { organizationList, projectList } = Shark.get();
		// const { currUser,  organizationList, organizationMembershipList, projectList } = Shark.get();

		// if (organizationList && organizationMembershipList) {
		// 	const writableOrganizationList = organizationList.filter(organization => {
		// 		const myMembership = organizationMembershipList.find(membership => membership.userGuid === currUser.guid);

		// 		return organization.ownerGuid === currUser.guid || [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_POWER_ADMIN, OrganizationMembership.ROLE_POWER_USER].includes(myMembership?.role);
		// 	});

		// 	Shark.set({
		// 		writableOrganizationList,
		// 	});
		// }

		if (organizationList && projectList && organizationList.length > 0 && projectList.length > 0) {
			const organizationMap = new Map();

			organizationList.forEach(item => {
				organizationMap.set(item.guid, item);
			});

			projectList.forEach(project => {
				if (organizationMap.has(project.organizationGuid)) {
					project.__organizationLabel = organizationMap.get(project.organizationGuid).name;
				}
			});

			Shark.set({
				projectList,
			});
		}
	}

	projectDetailPanelComponent_project_savedHandler (event, data) {
		// console.log("projectDetailPanelComponent_project_savedHandler", {event, data});
		this.refreshProjectList();
	}

	refreshProjectList () {
		// console.log("projectListComponent refreshProjectList");
		Shark.set({
			currProject: null,
			taskList: [],
			__loggedUserCanAddTask: false,
			__projectListLocalWaitboxCSSClasses: "",
		});

		const { activeItems, currUser, projectFilters, runningWorkSession } = Shark.get();

		activeItems.set({
			newProjectName: "",
			newProjectTags: "",
		});

		if (!currUser._feature_organization || projectFilters.organizationGuidList.length > 0) {
			projectManager.getList(projectFilters)
			.then(() => {
				const { projectList } = Shark.get();

				if (projectList) {
					if (runningWorkSession) {
						const runningWorkSessionProject = projectList.find(item => item.guid === runningWorkSession.projectGuid);
						if (runningWorkSessionProject) {
							runningWorkSessionProject.set({
								__isRunningWorkSessionProject: true,
							});
						}
					}
					this.filterProjectList(projectFilters.searchKey);
					this.sortProjectList(activeItems.projectSortField);
					this.matchProjectAndOrganization();
				}
				Shark.set({
					__projectListLocalWaitboxCSSClasses: "d-none",
				});
			});
		}
		else {
			Shark.set({
				projectList: [],
				__projectListLocalWaitboxCSSClasses: "d-none",
			});
		}
	}

	refreshPrjsBtn_clickHandler () {
		this.refreshProjectList();
	}

	selectAllOrganizationBtn_clickHandler () {
		let { projectFilters } = Shark.get();
		const { organizationList } = Shark.get();
		let organizationGuidList;
		
		if (projectFilters.organizationGuidList.length !== organizationList.length) {
			organizationGuidList = organizationList.map(item => item.guid);
		}
		else {
			organizationGuidList = [];
		}

		projectFilters.set({
			organizationGuidList,
		});

		// let organizationToAdd = organizationList.map(item => item.guid);
		// const __allOrganizationSelected = projectFilters.organizationGuidList.length < organizationToAdd.length;
		// if(__allOrganizationSelected) {
		// 	projectFilters.organizationGuidList = organizationToAdd;
		// }
		// else {
		// 	projectFilters.organizationGuidList = [];
		// }
		Shark.set({
			// projectFilters,
			__allOrganizationSelected: projectFilters.organizationGuidList.length === organizationList.length,
		});
		// console.log(projectFilters.organizationGuidList);
		// Shark.render(); // Mi aspetteri che lo tracciasse in automatico
	}

	selectInverseOrganizationBtn_clickHandler () {
		let { projectFilters, organizationList} = Shark.get();

		const organizationGuidList = organizationList.filter(item => !projectFilters.organizationGuidList.includes(item.guid)).map(item => item.guid);

		projectFilters.set({
			organizationGuidList,
			__allOrganizationSelected: projectFilters.organizationGuidList.length === organizationList.length,
		});
	}

	// selectNoneOrganizationBtn_clickHandler () {
	// 	let { projectFilters} = Shark.get();

	// 	projectFilters.set({
	// 		organizationGuidList: [],
	// 	});
	// 	// projectFilters.organizationGuidList = [];

	// 	// Shark.set({
	// 	// 	projectFilters,
	// 	// });
	// }

	async singleProject_clickHandler (event, data) {
		// console.log({event, data});

		Shark.$store.taskList = [];
		Shark.$store.taskColumnCSSClasses = "project-selected";
		Shark.$store.__taskListLocalWaitboxCSSClasses = "";

		const selectedProjectGuid = data.guid;
		let currProject;
		const { currUser, currWorkSession, organizationMembershipList, projectList/*, writableOrganizationList*/ } = Shark.get();

		projectList.forEach(item => {
			item.__selected = item.guid === selectedProjectGuid;
			
			if (item.__selected) {
				// item.__cssClasses.add("active");
				item.__renderer.addClasses("active");

				currProject = item;
				// selectedProjectGuid = currProject.guid;
				currWorkSession.set({
					clientGuid: currProject.clientGuid,
					projectGuid: currProject.guid,
					taskGuid: "",
				});
			}
			else {
				// item.__cssClasses.delete("active");
				item.__renderer.removeClasses("active");

			}
			// item.flattenCSSClasses();
		});

		// let loggedUserCanAddTask = false;

		if (organizationMembershipList) {
			const myMembership = organizationMembershipList.find(membership => currProject.organizationGuid === membership.organizationGuid && membership.userGuid === currUser.guid);
			Shark.$store.currUser.__canCurrUserAddTask = myMembership ? [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_POWER_ADMIN, OrganizationMembership.ROLE_POWER_USER, OrganizationMembership.ROLE_OWNER].includes(myMembership?.role) : [ User.SUBSCRIPTION_TYPE_ENTERPRISE, User.SUBSCRIPTION_TYPE_STARTER, User.SUBSCRIPTION_TYPE_TEAM].includes(currUser.subscriptionType);
			// loggedUserCanAddTask = writableOrganizationList.map(item => item.guid).includes(currProject.organizationGuid) || currProject.ownerGuid === currUser.guid || [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_POWER_ADMIN, OrganizationMembership.ROLE_POWER_USER].includes(myMembership?.role);
		}

		// console.log({projectList});

		Shark.set({
			currProject,
			currUser,
			projectList,
			__canCreateManualWorkSession: homeView.canCreateManualNewWorkSession(),
			__canStartWorkSession: homeView.canStartNewWorkSession(),
			// __loggedUserCanAddTask: loggedUserCanAddTask,
			__taskListLocalWaitboxCSSClasses: "",
		});

		const filters = { projectGuid: selectedProjectGuid };

		if (window.outerWidth > 576) {
			await homeView.refreshTaskList(filters);
		}
		else {
			await setTimeout(async () => {
				await homeView.refreshTaskList(filters);
			}, 250);
		}
	}

	sortProjectList (sortField) {
		const { activeItems, newlyAddedProject, projectList, projectSortDirection } = Shark.get();
		const newProjectSortDirection = activeItems.projectSortField === sortField ? (projectSortDirection === "DIR" ? "INV" : "DIR") : "DIR";
		const sortMultiplier = 1;//newProjectSortDirection === "INV" ? -1 : 1;

		// console.log({ projectSortField: activeItems.projectSortField, sortField, newProjectSortDirection, projectSortDirection});
		
		if (sortField === "name") {
			projectList.sort((a, b) => {
				if (a.guid === newlyAddedProject?.guid) {
					return -1;
				}
				else if (b.guid === newlyAddedProject?.guid) {
					return 1;
				}

				// Dave: Le funzioni di sorting dovrebbero stare in un componente apposito?
				return homeView.compareProjectByName(a, b, sortMultiplier);
			});
		}
		else if (sortField === "client"){
			projectList.sort((a, b) => {
				if (a.guid === newlyAddedProject?.guid) {
					return -1;
				}
				else if (b.guid === newlyAddedProject?.guid) {
					return 1;
				}

				// Dave: Le funzioni di sorting dovrebbero stare in un componente apposito?
				return homeView.compareProjectByClientName(a, b, sortMultiplier) || homeView.compareProjectByName(a, b, sortMultiplier);
			});
		}
		else {
			projectList.sort((a, b) => {
				if (a.guid === newlyAddedProject?.guid) {
					return -1;
				}
				else if (b.guid === newlyAddedProject?.guid) {
					return 1;
				}

				// Dave: Le funzioni di sorting dovrebbero stare in un componente apposito?
				return homeView.compareLastActivity(a, b, sortMultiplier) || homeView.compareProjectByName(a, b, sortMultiplier);
			});
		}

		Shark.set({
			newlyAddedProject: null,
			projectList,
			projectSortDirection: newProjectSortDirection,
		});
	}

}

const projectListComponent = new ProjectListComponent();

Shark.registerComponent(projectListComponent);

export default projectListComponent;